var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-card',{staticClass:"mx-auto pa-5 text-center",attrs:{"flat":""}},[_c('v-card-text',[_c('p',{staticClass:"display-1 text--disabled"},[_vm._v(" Not Implemented ")]),_c('div',{staticClass:"text--disabled"},[_vm._v(" This hasnt been implemented yet. ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }